import React, { useEffect, useState } from "react";
import SaveButton from "../../../components/Buttons/SaveButton";
import SelectListField from "../../../components/Fields/SelectListField";
import { FormConfig } from "../../../components/Fields/Types";
import useSelectListOptions from "../../../components/Hooks/SelectListOptionsHook/useSelectListOptions";
import useValidation from "../../../components/Hooks/ValidationHook/useValidation";
import Popup from "../../../components/Popups/Popup";
import { useNotifications } from "../../../contexts/notificationContext";
import DataService from "../../../services/data.service";
import { LicensePopupProps } from "../../../types/PopupProps";
import { Result } from "../../../types/Result";

interface LicenseCountryModel {
    licenseId: number
    countryId: number
    included: boolean
    excluded: boolean
}

const AddCountryPopup: React.FC<LicensePopupProps> = ({ show, onHide, licenseId, included }) => {
    const [serverErrors, setServerErrors] = useState<Result>({ isSuccesful: true, messages: [] });
    const { handleResult, handleException } = useNotifications();

    const [formData, setFormData] = useState<LicenseCountryModel>({
        licenseId: licenseId,
        countryId: 0,
        included: included,
        excluded: !included
    });

    const countries = useSelectListOptions('api/v1/selectlist/Countries', '-- Select country');

    useEffect(() => {
        formData.included = included;
        formData.excluded = !included;
        setFormData(formData);

    }, [included]);

    function submit() {
        if (formData) {
            DataService
                .create<LicenseCountryModel>(`api/v1/LicenseCountries`, formData)
                .then(response => {
                    handleResult(response);
                    setServerErrors(response);
                    if (response.isSuccesful === true) {
                        if (onHide)
                            onHide();
                    }
                })
                .catch(e => handleException(e));
        }
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'countryId', label: 'Country', labelSize: 2, validationRules: [{ type: 'isRequired' }] },
        ],
        handleSubmit: submit,
        showErrors: 'always',
    };

    const { getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    return (
        <Popup show={show} onHide={onHide} size={'lg'} title={included ? 'Include country in License' : 'Exclude country from License'}>
            <Popup.Body>
                <SelectListField {...getFieldProps('countryId')} options={countries} />
            </Popup.Body>
            <Popup.Footer>
                <SaveButton {...getSubmitButtonProps()} />
            </Popup.Footer>
        </Popup>
    );
}
export default AddCountryPopup;